import React from 'react'
import { benefitsScroller } from 'services/PageScroller'
import { withLocalization, Text as TextType } from 'hocs/localization'
import Heading from 'elements/Heading'
import Text from 'elements/Text'
import item1 from './assets/item1.jpg'
import item2 from './assets/item2.jpg'
import item3 from './assets/item3.jpg'
import * as styles from './Benefits.scss'

interface IProps {
  t: TextType,
}

const ITEMS = [
  {
    image: item1,
    imageHeight: 123,
  },
  {
    image: item2,
    imageHeight: 123,
  },
  {
    image: item3,
    imageHeight: 123,
  },
]

const Benefits: React.FC<IProps> = ({ t }) => (
  <section id={benefitsScroller.getElementId()} className={styles.root}>
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <header className={styles.header}>
            <Heading title={t('header')} size={2} styleType='sectionHeader' />
          </header>
        </div>
        <div className='col-md-12'>
          <ul className={styles.list}>
            {ITEMS.map(({ image, imageHeight }, index) => (
              <li key={index} className={styles.item}>
                <img src={image} height={imageHeight} style={{ minHeight: imageHeight }} />
                <Heading title={t(`item${index + 1}.header`)} size={3} />
                <div className={styles.itemDescription}>
                  <Text size='large'>
                    {t(`item${index + 1}.description`)}
                  </Text>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
)

export default withLocalization('home.main.benefits')(Benefits)
